// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_3jSVeZIU","showDetailsSection":"_2hdiAEfO"};